import { Dispatch, SetStateAction } from "react";

const InfoIcon = `
<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-info" class="svg-inline--fa fa-circle-info fill-blue-600" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-144c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"></path></svg>
`;

const overlayHTML = `
  <div class="overlay-info absolute w-max {{POS}} border border-blue-600 px-4 py-1 z-20 cursor-pointer space-x-2 rounded-md">
    {{ICON}}
    <a href="{{HREF}}" target="_blank">{{TITLE}}</a>
  <div>
`;

const buildOverlayHTML = (title: string, href: string, icon: string, position: "TL" | "TR" | "BL" | "BR") => {
  let pos = "";
  switch (position) {
    case "TL":
      pos = "top-0 left-1 link bg-white";
      break;
    case "BL":
      pos = "bottom-10 left-1 bg-blue-600 text-white";
      break;
    case "BR":
      pos = "bottom-10 right-1 bg-blue-600 text-white";
      break;
    case "TR":
    default:
      pos = "top-0 right-1 link bg-white";
      break;
  }

  let iconStr = "";
  switch (icon) {
    case "INFO":
      iconStr = InfoIcon;
      break;
    default:
      break;
  }
  return overlayHTML.replace("{{POS}}", pos)
    .replace("{{ICON}}", iconStr)
    .replace("{{TITLE}}", title)
    .replace("{{HREF}}", href);
}

export const createOverlayInfo = (index: number, playerRef: any, setState?: Dispatch<SetStateAction<number>>, params?: {
  title: string;
  href: string;
  position: "TL" | "TR" | "BL" | "BR";
  hideOnClick?: boolean;
  icon: string;
}) => {
  const div = document.createElement("div");
  if (!params || !params.title || !params.href) {
    return div;
  }
  div.innerHTML = buildOverlayHTML(params.title, params.href, params.icon, params.position);
  div.onclick = () => {
    if (setState) {
      setState(index);
    }
    if (params.hideOnClick) {
      div.innerHTML = "";
    }
  };
  return div;
}
